import { useMemo } from "react";
import {
  ApiChartTemplate,
  ApiChartType,
  ApiDimension,
  ApiMetric,
} from "@incendium/api";
import { ShoppingCart } from "@mui/icons-material";
import StandardAnalyticsChartStatCard from "features/analytics/components/StandardAnalyticsChartStatCard";
import { CHART_KEY_STORE_CUSTOMER_RETENTION_AVG_ORDERS_REPEAT_CUSTOMERS } from "features/analytics/constants/chartKeys";
import { useCustomerRetentionCohort } from "../context/CustomerRetentionCohortProvider";

function RepeatCustomerAvgOrdersStatCard() {
  const { dateDimension } = useCustomerRetentionCohort();

  const chart = useMemo(
    () => ({
      name: "Avg. Orders (Repeat Customers)",
      dimension: [ApiDimension.DIMENSION_NOT_SET],
      template: ApiChartTemplate.SNAPSHOT,
      type: ApiChartType.STAT_CARD,
      dateDimension,
      attributes: [],
      yAxisKeys: [
        {
          key: "l",
          fields: [ApiMetric.METRIC_AVERAGE_REPEAT_CUSTOMER_ORDERS],
        },
      ],
      displayOptions: {
        statTitle: "Avg. Orders (Repeat Customers)",
        statDesignIndex: 3,
      },
      comparison: true,
    }),
    [dateDimension],
  );

  return (
    <StandardAnalyticsChartStatCard
      chartKey={CHART_KEY_STORE_CUSTOMER_RETENTION_AVG_ORDERS_REPEAT_CUSTOMERS}
      icon={<ShoppingCart />}
      chart={chart}
    />
  );
}

export default RepeatCustomerAvgOrdersStatCard;
